export class StorePassword extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger', 'login', 'newsletter']
  }

  setupListeners () {
    super.setupListeners()

    this.onTriggerClick = this.onTriggerClick.bind(this)

    this.listeners.add(this.els.trigger.element, 'click', this.onTriggerClick)
  }

  onTriggerClick () {
    this.els.newsletter.element.hidden = !this.loginIsVisible
    this.els.login.element.hidden = this.loginIsVisible

    this.els.triggertext.element.innerHTML = this.loginIsVisible
      ? this.els.triggertext.element.dataset.formTrigger
      : this.els.triggertext.element.dataset.adminTrigger

    if (this.loginIsVisible) {
      this.els.login.element.querySelector('input')?.focus()
    }
  }

  get loginIsVisible () {
    return !this.els.login.element.hidden
  }
}

if (!customElements.get('store-password')) {
  customElements.define('store-password', StorePassword)
}
